import React, { useEffect, useState } from 'react';
import img1 from '../asset/img/1.png'
import img2 from '../asset/img/4.png'
import img3 from '../asset/img/2.png'
import img4 from '../asset/img/3.png'

import logoJs from '../asset/icons/js.png'
import logoTypescript from '../asset/icons/typescript.png'
import logoReact from '../asset/icons/react.png'
import logoNode from '../asset/icons/nodejs.png'
import logoNext from '../asset/icons/nextjs.png'
import logoTailwind from '../asset/icons/tailwind.png'
import logoFirebase from '../asset/icons/firebase.png'
import { portfolioList } from '../data/portfolios';

export default function Home() {

  const [currentPage, setCurrentPage] = useState(1)

  function setPage(pageNum) {
    setCurrentPage(pageNum)
  }

  useEffect(() => {
    const imageElement = document.getElementsByClassName('animate-img');
    animate(imageElement, 'animate-bouncein')

  }, [currentPage])

  useEffect(() => {
    const imageElement = document.getElementsByClassName('animate-img');

    document.addEventListener('scroll', () => {
      animate(imageElement, 'animate-bouncein')
    })
  }, [])

  function animate(array, className) {
    for (let el of array) {
      const rect = el.getBoundingClientRect()
      const isInView = (
        rect.top >= (el.clientHeight * -1) &&
        rect.top <= window.innerHeight
      )
      if (isInView) {
        el.classList.add(className)
      }
      else el.classList.remove(className)
    }
  }

  function getAge() {
    const birthYear = 1996
    const birthMonth = 8
    const birthDay = 17
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1
    const currentDay = currentDate.getDate();

    let age = currentYear - birthYear;
    if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
      age--;
    }
    return age + 1;
  }

  return (
    <div className='w-full lg:px-8 flex flex-col items-stretch justify-start'>
      <div className=' flex flex-row items-center justify-between text-xl'>
        <button className='text-4xl font-black p-8'>Welcome</button>
      </div>
      <div className='flex flex-row items-stretch justify-start mt-4 h-full flex-wrap-reverse pb-24'>
        <div className='lg:w-1/2 w-full flex flex-col items-stretch justify-start'>
          <div className='h-fit w-full p-8 my-auto' id="content">
            {currentPage === 1 &&
              <div className='no-scrollbar pb-32 lg:pb-0'>
                <div className='flex flex-row items-start justify-between w-full flex-wrap'>

                  <p className=' leading-8 lg:w-1/2 w-full lg:border-r lg:border-lime-500 lg:pr-8 text-center lg:text-left'> <span className='text-6xl font-bold leading-8 pr-4'>
                    Hi,</span> people call me Oan, and sometimes Yolanda.
                    Currently working as Software Engineer at <strong>Accelbyte</strong>.
                    {' '} My latest client was <a href='https://www.2k.com/en-US/' className=' text-blue-400'>2K Games</a>.
                    {' '} Working on their internal platform. Using React and NodeJs.
                  </p>

                  <div className='flex flex-col items-stretch justify-start gap-1 lg:pl-8 lg:w-1/2 w-full mt-12 lg:mt-0'>
                    <div className='flex items-center justify-center gap-2 text-center'>
                      <div className='font-semibold text-4xl'>Yolanda Ihsan</div>
                    </div>
                    <div className='flex items-center justify-center gap-2 text-center'>
                      <div>Software Engineer</div>
                    </div>
                    <div className='flex items-center justify-center gap-2 mt-2'>
                      <span className="material-symbols-outlined">
                        badge
                      </span>
                      <a className='text-sky-600' href='https://accelbyte.net/' target={'_blank'} rel="noreferrer">Accelbyte</a>
                    </div>

                    <div className='flex items-center justify-center gap-2 mt-8 text-center italic text-sm text-lime-600'>
                      <a href='https://www.google.com/maps/@-0.1688204,100.6596827,16.75z' target={'_blank'} rel="noreferrer">Working remotely from 50 Kota District, West Sumatera</a>
                    </div>
                  </div>
                </div>

                <div className='mt-4 -mb-4 font-semibold text-center text-green-600'>Education</div>

                <div className='flex flex-row items-start justify-center gap-4 pt-8 flex-wrap'>
                  <a className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-sky-600 text-white gap-2 shrink-0 hover:shadow-lg transition-all duration-300' href='https://pcr.ac.id/'>
                    <span className="material-symbols-outlined">school</span> Politeknik Caltex Riau</a>
                  <div className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-sky-500 text-white gap-2 shrink-0'>
                    <span className="material-symbols-outlined">psychology</span> Informatics Engineering</div>
                  <div className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-sky-500 text-white gap-2 shrink-0'>
                    <span className="material-symbols-outlined">insights</span> 3.68 GPA</div>
                </div>

                <div className='mt-4 -mb-4 font-thin text-center text-lime-600'>Other</div>
                <div className='flex flex-row items-start justify-center gap-4 pt-8 flex-wrap'>
                  <div className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-green-500 text-white gap-2 shrink-0'>
                    <span className="material-symbols-outlined"> crib</span> {getAge()} years old</div>
                  <div className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-yellow-500 text-white gap-2 shrink-0'>
                    <span className="material-symbols-outlined">favorite</span> Music</div>
                  <div className='flex flex-row items-center justify-center px-4 py-1 rounded-full bg-orange-500 text-white gap-2 shrink-0'>
                    <span className="material-symbols-outlined">flight</span> Travel</div>
                </div>
              </div>
            }

            {currentPage === 2 &&
              <div className='flex flex-col items-center justify-start gap-4 flex-wrap gap-y-8 p-8 pb-32 lg:pb-8 flex-wrap  '>
                <div className='flex flex-row items-center justify-center flex-wrap  gap-8'>
                  <img src={logoJs} alt="JS logo" className='w-24 animate-img opacity-0' />
                  <img src={logoTypescript} alt="JS logo" className='w-56 animate-img opacity-0' />
                </div>

                <div className='flex flex-row items-center justify-center flex-wrap gap-8'>
                  <img src={logoReact} alt="JS logo" className='w-48 animate-img opacity-0' />
                  <img src={logoNext} alt="JS logo" className='w-48 animate-img opacity-0' />
                  <img src={logoNode} alt="JS logo" className='w-48 animate-img opacity-0' />
                </div>

                <div className='flex flex-row items-center justify-center flex-wrap gap-8'>
                  <img src={logoTailwind} alt="JS logo" className='w-48 animate-img opacity-0' />
                  <img src={logoFirebase} alt="JS logo" className='w-48 animate-img opacity-0' />
                </div>
              </div>
            }

            {currentPage === 3 &&
              <div className='flex flex-row items-start justify-start flex-wrap gap-y-8 p-8 pb-32 pb-32 border-2 border-solid rounded-lg border-neutral-50'>
                {portfolioList.map(item => <div className=' w-full w-auto h-fit rounded-xl flex flex-col items-stretch justify-start gap-2 overflow-clip p-8 shadow-lg'>
                  <div className='flex flex-row items-center justify-center gap-4'>
                    <img src={item.image} className='w-1/3 object-cover h-full' alt='landx logo'></img>
                    <div className='w-full flex flex-col items-start justify-start gap-2 '>
                      <div className='font-normal text-lg text-black uppercase'>{item.title}</div>
                    </div>
                  </div>

                  <div className='text-gray-500 text-sm'>{item.brief}</div>
                  {item.jobdesk.length > 0 &&
                    <>
                      <div className='text-gray-500 text-sm font-semibold'>Jobdesk :</div>
                      <ul className='text-gray-500 text-sm list-disc list-inside'>
                        {item.jobdesk.map(jobdesk => <li>{jobdesk}</li>)}
                      </ul>
                    </>
                  }


                  <div className=' text-sm mt-6 font-semibold'>Tech Stack : </div>
                  <ul className='text-gray-500 text-sm list-disc list-inside'>
                    {item.techStack.map(tech => <li>{tech}</li>)}
                  </ul>

                  <div className=' text-sm mt-6 font-semibold'>Duration : </div>
                  <div className=' text-sm -mt-2 font-thin'>{item.startDate} - {item.endDate}</div>
                  {item.links.map(link => <a className=' text-sm text-lime-500' href={link.href} target={'_blank'} rel="noreferrer">{link.title}</a>)}
                </div>)}
              </div>
            }

            {currentPage === 4 &&
              <div className='flex lg:flex-row flex-col flex-wrap items-center justify-center gap-8 h-80 my-auto text-4xl pb-12 '>
                <a className='flex flex-row items-center justify-start gap-2 ' href='mailto:coxskazoku@gmail.com' target={'_blank'} rel="noreferrer">
                  <span className="material-symbols-outlined text-5xl">
                    mail
                  </span>
                  <div>coxskazoku@gmail.com</div>
                </a>
                <a className='flex flex-row items-center justify-start gap-2' href='https://www.linkedin.com/in/yolandaihsan/' target={'_blank'} rel="noreferrer">
                  <span className="material-symbols-outlined text-5xl">
                    work
                  </span>
                  <div>Linkedin</div>
                </a>
                <a className='flex flex-row items-center justify-start gap-2' href='https://github.com/yolandaihsan17' target={'_blank'} rel="noreferrer">
                  <span className="material-symbols-outlined text-5xl">
                    nature
                  </span>
                  <div>Github</div>
                </a>
              </div>
            }

          </div>

          <div className=' fixed left-0 bottom-0 xl:flex flex-row items-start justify-center gap-8 my-auto w-full flex-wrap hidden bg-white/40 backdrop-blur-sm  '>
            <button onClick={() => setPage(1)} className='w-24 h-24 flex flex-col items-center justify-start gap-2 p-4 rounded-md hover:shadow-inner hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-3xl">
                face
              </span>
              <div className='text-lg'>Profile </div>
            </button>
            <button onClick={() => setPage(2)} className='w-24 h-24 flex flex-col items-center justify-start gap-2 p-4 rounded-md hover:shadow-inner hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-3xl">
                military_tech
              </span>
              <div className='text-lg'>Skill Set</div>
            </button>
            <button onClick={() => setPage(3)} className='w-24 h-24 flex flex-col items-center justify-start gap-2 p-4 rounded-md hover:shadow-inner hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-3xl">
                work
              </span>
              <div className='text-lg'>Portfolio</div>
            </button>
            <button onClick={() => setPage(4)} className='w-24 h-24 flex flex-col items-center justify-start gap-2 p-4 rounded-md hover:shadow-inner hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-3xl">
                phone_in_talk
              </span>
              <div className='text-lg'>Contacts</div>
            </button>
          </div>

          <div className=' bottom-0 left-0 w-full fixed flex flex-row items-start justify-center gap-8 my-auto flex-nowrap xl:hidden bg-white/80 backdrop-blur-md px-8'>
            <button onClick={() => setPage(1)} className='w-1/5 h-20 flex flex-col items-center justify-start p-4 rounded-md hover:shadow-inner hover:-translate-x-1 hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-2xl">
                face
              </span>
              <div className='text-lg'>Profile </div>
            </button>
            <button onClick={() => setPage(2)} className='w-1/5 h-20 flex flex-col items-center justify-start p-4 rounded-md hover:shadow-inner hover:-translate-x-1 hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-2xl">
                military_tech
              </span>
              <div className='text-lg whitespace-nowrap'>Skill Set</div>
            </button>
            <button onClick={() => setPage(3)} className='w-1/5 h-20  lex flex-col items-center justify-start p-4 rounded-md hover:shadow-inner hover:-translate-x-1 hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-2xl">
                work
              </span>
              <div className='text-lg'>Portfolio</div>
            </button>
            <button onClick={() => setPage(4)} className='w-1/5 h-20 flex flex-col items-center justify-start p-4 rounded-md hover:shadow-inner hover:-translate-x-1 hover:translate-y-1 transition-all duration-300'>
              <span className="material-symbols-outlined text-2xl">
                phone_in_talk
              </span>
              <div className='text-lg'>Contacts</div>
            </button>
          </div>
        </div>

        <div className=' w-full lg:w-1/2 p-4 object-fit mx-auto'>
          <img src={img1} className={`mx-auto w-full max-w-md lg:max-w-2xl ${currentPage === 1 ? 'block' : 'hidden'} animate-img opacity-0`} alt='character 1'></img>
          <img src={img2} className={`mx-auto w-full max-w-md lg:max-w-2xl ${currentPage === 2 ? 'block' : 'hidden'} animate-img opacity-0`} alt='character 2'></img>
          <img src={img3} className={`mx-auto w-full max-w-md lg:max-w-2xl ${currentPage === 3 ? 'block' : 'hidden'} animate-img opacity-0`} alt='character 3'></img>
          <img src={img4} className={`mx-auto w-full max-w-md lg:max-w-2xl ${currentPage === 4 ? 'block' : 'hidden'} animate-img opacity-0`} alt='character 4'></img>
        </div>

      </div>
    </div >
  )
}